<script lang="ts">
  import { splitPow } from './notation';

  /** `10^k` を上付きで描く（テキストの正本は `10^k`）。 */
  interface Props {
    text: string;
  }

  let { text }: Props = $props();
  const parts = $derived(splitPow(text));
</script>

{#each parts as part, i (i)}{#if part.sup}<sup>{part.text}</sup>{:else}{part.text}{/if}{/each}
